// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import { getGroupedByCountryStateOptionsByConfig } from '../../../helpers/options';
// feature fuel-cards
import * as C from '../constants';
//////////////////////////////////////////////////

export const FILTER_PARAMS = [
  {
    type: 'string',
    value: GC.GRC.DRIVER_FIRST_NAME,
    name: `${G.getWindowLocale('titles:driver', 'Driver')}: ${
      G.getWindowLocale('titles:first-name', 'First Name')}`,
  },
  {
    type: 'string',
    value: GC.GRC.DRIVER_LAST_NAME,
    name: `${G.getWindowLocale('titles:driver', 'Driver')}: ${
      G.getWindowLocale('titles:last-name', 'Last Name')}`,
  },
  {
    type: 'string',
    value: GC.GRC.DRIVER_FULL_NAME,
    name: `${G.getWindowLocale('titles:driver', 'Driver')}: ${G.getWindowLocale('titles:full-name', 'Full Name')}`,
  },
  {
    type: 'string',
    value: `${GC.SYSTEM_OBJECT_DRIVER}.${GC.FIELD_FLEET_LOGIN_ID}`,
    name: `${G.getWindowLocale('titles:driver', 'Driver')}: ${
      G.getWindowLocale('titles:login-id', 'Login ID')}`,
  },
  {
    type: 'string',
    value: GC.GRC.DRIVER_VENDOR_NAME,
    name: `${G.getWindowLocale('titles:driver', 'Driver')}: ${G.getWindowLocale('titles:vendor-name', 'Vendor Name')}`,
  },
  {
    type: 'string',
    value: C.RC.TRUCK_UNIT_ID,
    name: `${G.getWindowLocale('titles:truck', 'Truck')}: ${
      G.getWindowLocale('titles:unit-id', 'Unit ID')}`,
  },
  {
    type: 'string',
    value: GC.GRC.DRIVER_PAYROLL_NUMBER,
    name: G.getWindowLocale('titles:payroll-number', 'Payroll #'),
  },
  {
    type: 'string',
    value: GC.GRC.VENDOR_PAYROLL_NUMBER,
    name: G.getWindowLocale('titles:vendor-payroll-number', 'Vendor Payroll #'),
  },
  {
    type: 'date',
    value: GC.FIELD_FUEL_CARDS_TRANSACTION_DATE,
    name: G.getWindowLocale('titles:transaction-date', 'Transaction Date'),
  },
  {
    type: 'number',
    value: GC.FIELD_FUEL_CARDS_EXCLUDED_TOTAL,
    name: G.getWindowLocale('titles:excluded-total', 'Excluded Total'),
  },
  {
    type: 'number',
    value: GC.FIELD_FUEL_CARDS_PAYABLE_TOTAL,
    name: G.getWindowLocale('titles:payable-total', 'Payable Total'),
  },
  {
    type: 'number',
    value: GC.FIELD_PAYABLE_VENDOR_TOTAL,
    name: G.getWindowLocale('titles:payable-vendor-total', 'Payable Vendor Total'),
  },
  {
    type: 'number',
    value: GC.FIELD_PAYABLE_COMPANY_TOTAL,
    name: G.getWindowLocale('titles:payable-company-total', 'Payable Company Total'),
  },
  {
    type: 'number',
    value: GC.FIELD_TOTAL,
    name: G.getWindowLocale('titles:-total', 'Total'),
  },
  {
    type: 'string',
    value: GC.FIELD_TRIP_ID,
    name: G.getWindowLocale('titles:trip-id', 'Trip ID'),
  },
  {
    type: 'string',
    value: GC.FIELD_ACCOUNT_ID,
    name: G.getWindowLocale('titles:account-id', 'Account ID'),
  },
  {
    type: 'string',
    value: GC.FIELD_FUEL_CARDS_SOURCE,
    name: G.getWindowLocale('titles:source', 'Source'),
  },
  {
    type: 'string',
    value: GC.FIELD_FUEL_CARDS_TRANSACTION_NUMBER,
    name: G.getWindowLocale('titles:transaction-number', 'Transaction Number'),
  },
  {
    type: 'string',
    value: C.RC.FUEL_CARDS_TRANSACTION_STOP_LOCATION_NAME,
    name: G.getWindowLocale('titles:location-name', 'Location Name'),
  },
  {
    type: 'string',
    value: C.RC.FUEL_CARDS_TRANSACTION_STOP_ADDRESS,
    name: G.getWindowLocale('titles:address', 'Address'),
  },
  {
    type: 'string',
    value: C.RC.FUEL_CARDS_TRANSACTION_STOP_CITY,
    name: G.getWindowLocale('titles:city', 'City'),
  },
  {
    type: 'selectMultipleCreatable',
    value: C.RC.FUEL_CARDS_TRANSACTION_STOP_STATE,
    options: getGroupedByCountryStateOptionsByConfig,
    name: G.getWindowLocale('titles:state', 'State'),
  },
  {
    type: 'string',
    value: C.RC.FUEL_CARDS_TRANSACTION_STOP_COUNTRY,
    name: G.getWindowLocale('titles:country', 'Country'),
  },
  {
    type: 'string',
    value: GC.FIELD_CURRENCY,
    name: G.getWindowLocale('titles:currency', 'Currency'),
  },
  {
    type: 'string',
    value: GC.FIELD_FUEL_CARDS_CARD_ID,
    name: G.getWindowLocale('titles:card-id', 'Card Id'),
  },
  {
    type: 'string',
    value: GC.FIELD_CREATED_BY,
    name: G.getWindowLocale('titles:created-by', 'Created By'),
  },
  {
    type: 'date',
    value: GC.FIELD_CREATED_DATE,
    name: G.getWindowLocale('titles:created-date', 'Created Date'),
  },
  {
    type: 'string',
    value: GC.FIELD_LAST_MODIFIED_BY,
    name: G.getWindowLocale('titles:last-modified-by', 'Updated By'),
  },
  {
    type: 'date',
    value: GC.FIELD_LAST_MODIFIED_DATE,
    name: G.getWindowLocale('titles:last-modified-date', 'Updated On'),
  },
  {
    type: 'string',
    collection: true,
    value: C.RC.FUEL_CARDS_LINES_PRODUCT_NAME,
    name: G.getWindowLocale('titles:product-name', 'Product Name'),
  },
  {
    type: 'number',
    collection: true,
    value: C.RC.FUEL_CARDS_LINES_QUANTITY,
    name: G.getWindowLocale('titles:quantity', 'Quantity'),
  },
  {
    type: 'string',
    collection: true,
    value: C.RC.FUEL_CARDS_LINES_UOM,
    name: G.getWindowLocale('titles:uom', 'UOM'),
  },
  {
    type: 'boolean',
    value: GC.FIELD_HAS_FUEL,
    name: G.getWindowLocale('titles:has-fuel', 'Has Fuel'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_ID,
    name: G.getWindowLocale('titles:integration-id', 'Integration ID'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_TRANSACTION_NUMBER,
    name: G.getWindowLocale('titles:integration-transaction-number', 'Integration Transaction Number'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_STATUS,
    name: G.getWindowLocale('titles:integration-status', 'Integration Status'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_TYPE,
    name: G.getWindowLocale('titles:integration-type', 'Integration Type'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_ERROR,
    name: G.getWindowLocale('titles:integration-error', 'Integration Error'),
  },
  {
    type: 'string',
    value: GC.GRC.ACCOUNTING_INTEGRATION_LAST_MODIFIED_BY,
    name: G.getWindowLocale('titles:integrated-by', 'Integrated By'),
  },
  {
    type: 'number',
    value: GC.FIELD_SOURCE_DISCOUNT_TOTAL,
    name: G.getWindowLocale('titles:source-discount-total', 'Source Discount Total'),
  },
];
